export const countryFieldValue = [
  { label: 'USA', value: 'USA', defaultValue: false },
  {
    defaultValue: false,
    label: 'Afghanistan',
    value: 'Afghanistan',
  },
  {
    defaultValue: false,
    label: 'Åland Islands',
    value: 'Åland Islands',
  },
  {
    defaultValue: false,
    label: 'Albania',
    value: 'Albania',
  },
  {
    defaultValue: false,
    label: 'Algeria',
    value: 'Algeria',
  },
  {
    defaultValue: false,
    label: 'American Samoa',
    value: 'American Samoa',
  },
  {
    defaultValue: false,
    label: 'Andorra',
    value: 'Andorra',
  },
  {
    defaultValue: false,
    label: 'Angola',
    value: 'Angola',
  },
  {
    defaultValue: false,
    label: 'Anguilla',
    value: 'Anguilla',
  },
  {
    defaultValue: false,
    label: 'Antarctica',
    value: 'Antarctica',
  },
  {
    defaultValue: false,
    label: 'Antigua and Barbuda',
    value: 'Antigua and Barbuda',
  },
  {
    defaultValue: false,
    label: 'Argentina',
    value: 'Argentina',
  },
  {
    defaultValue: false,
    label: 'Armenia',
    value: 'Armenia',
  },
  {
    defaultValue: false,
    label: 'Aruba',
    value: 'Aruba',
  },
  {
    defaultValue: false,
    label: 'Australia',
    value: 'Australia',
  },
  {
    defaultValue: false,
    label: 'Austria',
    value: 'Austria',
  },
  {
    defaultValue: false,
    label: 'Azerbaijan',
    value: 'Azerbaijan',
  },
  {
    defaultValue: false,
    label: 'Bahamas',
    value: 'Bahamas',
  },
  {
    defaultValue: false,
    label: 'Bahrain',
    value: 'Bahrain',
  },
  {
    defaultValue: false,
    label: 'Bangladesh',
    value: 'Bangladesh',
  },
  {
    defaultValue: false,
    label: 'Barbados',
    value: 'Barbados',
  },
  {
    defaultValue: false,
    label: 'Belarus',
    value: 'Belarus',
  },
  {
    defaultValue: false,
    label: 'Belgium',
    value: 'Belgium',
  },
  {
    defaultValue: false,
    label: 'Belize',
    value: 'Belize',
  },
  {
    defaultValue: false,
    label: 'Benin',
    value: 'Benin',
  },
  {
    defaultValue: false,
    label: 'Bermuda',
    value: 'Bermuda',
  },
  {
    defaultValue: false,
    label: 'Bhutan',
    value: 'Bhutan',
  },
  {
    defaultValue: false,
    label: 'Bolivia (Plurinational State of)',
    value: 'Bolivia (Plurinational State of)',
  },
  {
    defaultValue: false,
    label: 'Bonaire, Sint Eustatius and Saba',
    value: 'Bonaire, Sint Eustatius and Saba',
  },
  {
    defaultValue: false,
    label: 'Bosnia and Herzegovina',
    value: 'Bosnia and Herzegovina',
  },
  {
    defaultValue: false,
    label: 'Botswana',
    value: 'Botswana',
  },
  {
    defaultValue: false,
    label: 'Bouvet Island',
    value: 'Bouvet Island',
  },
  {
    defaultValue: false,
    label: 'Brazil',
    value: 'Brazil',
  },
  {
    defaultValue: false,
    label: 'British Indian Ocean Territory',
    value: 'British Indian Ocean Territory',
  },
  {
    defaultValue: false,
    label: 'Brunei Darussalam',
    value: 'Brunei Darussalam',
  },
  {
    defaultValue: false,
    label: 'Bulgaria',
    value: 'Bulgaria',
  },
  {
    defaultValue: false,
    label: 'Burkina Faso',
    value: 'Burkina Faso',
  },
  {
    defaultValue: false,
    label: 'Burundi',
    value: 'Burundi',
  },
  {
    defaultValue: false,
    label: 'Cabo Verde',
    value: 'Cabo Verde',
  },
  {
    defaultValue: false,
    label: 'Cambodia',
    value: 'Cambodia',
  },
  {
    defaultValue: false,
    label: 'Cameroon',
    value: 'Cameroon',
  },
  {
    defaultValue: false,
    label: 'Canada',
    value: 'Canada',
  },
  {
    defaultValue: false,
    label: 'Cayman Islands',
    value: 'Cayman Islands',
  },
  {
    defaultValue: false,
    label: 'Central African Republic',
    value: 'Central African Republic',
  },
  {
    defaultValue: false,
    label: 'Chad',
    value: 'Chad',
  },
  {
    defaultValue: false,
    label: 'Chile',
    value: 'Chile',
  },
  {
    defaultValue: false,
    label: 'China',
    value: 'China',
  },
  {
    defaultValue: false,
    label: 'Christmas Island',
    value: 'Christmas Island',
  },
  {
    defaultValue: false,
    label: 'Cocos (Keeling) Islands',
    value: 'Cocos (Keeling) Islands',
  },
  {
    defaultValue: false,
    label: 'Colombia',
    value: 'Colombia',
  },
  {
    defaultValue: false,
    label: 'Comoros',
    value: 'Comoros',
  },
  {
    defaultValue: false,
    label: 'Congo (the Democratic Republic of the)',
    value: 'Congo (the Democratic Republic of the)',
  },
  {
    defaultValue: false,
    label: 'Congo',
    value: 'Congo',
  },
  {
    defaultValue: false,
    label: 'Cook Islands',
    value: 'Cook Islands',
  },
  {
    defaultValue: false,
    label: 'Costa Rica',
    value: 'Costa Rica',
  },
  {
    defaultValue: false,
    label: 'Croatia',
    value: 'Croatia',
  },
  {
    defaultValue: false,
    label: 'Cuba',
    value: 'Cuba',
  },
  {
    defaultValue: false,
    label: 'Curaçao',
    value: 'Curaçao',
  },
  {
    defaultValue: false,
    label: 'Cyprus',
    value: 'Cyprus',
  },
  {
    defaultValue: false,
    label: 'Czechia',
    value: 'Czechia',
  },
  {
    defaultValue: false,
    label: "Côte d'Ivoire",
    value: "Côte d'Ivoire",
  },
  {
    defaultValue: false,
    label: 'Denmark',
    value: 'Denmark',
  },
  {
    defaultValue: false,
    label: 'Djibouti',
    value: 'Djibouti',
  },
  {
    defaultValue: false,
    label: 'Dominica',
    value: 'Dominica',
  },
  {
    defaultValue: false,
    label: 'Dominican Republic',
    value: 'Dominican Republic',
  },
  {
    defaultValue: false,
    label: 'Ecuador',
    value: 'Ecuador',
  },
  {
    defaultValue: false,
    label: 'Egypt',
    value: 'Egypt',
  },
  {
    defaultValue: false,
    label: 'El Salvador',
    value: 'El Salvador',
  },
  {
    defaultValue: false,
    label: 'Equatorial Guinea',
    value: 'Equatorial Guinea',
  },
  {
    defaultValue: false,
    label: 'Eritrea',
    value: 'Eritrea',
  },
  {
    defaultValue: false,
    label: 'Estonia',
    value: 'Estonia',
  },
  {
    defaultValue: false,
    label: 'Eswatini',
    value: 'Eswatini',
  },
  {
    defaultValue: false,
    label: 'Ethiopia',
    value: 'Ethiopia',
  },
  {
    defaultValue: false,
    label: 'Falkland Islands [Malvinas]',
    value: 'Falkland Islands [Malvinas]',
  },
  {
    defaultValue: false,
    label: 'Faroe Islands',
    value: 'Faroe Islands',
  },
  {
    defaultValue: false,
    label: 'Fiji',
    value: 'Fiji',
  },
  {
    defaultValue: false,
    label: 'Finland',
    value: 'Finland',
  },
  {
    defaultValue: false,
    label: 'France',
    value: 'France',
  },
  {
    defaultValue: false,
    label: 'French Guiana',
    value: 'French Guiana',
  },
  {
    defaultValue: false,
    label: 'French Polynesia',
    value: 'French Polynesia',
  },
  {
    defaultValue: false,
    label: 'French Southern Territories',
    value: 'French Southern Territories',
  },
  {
    defaultValue: false,
    label: 'Gabon',
    value: 'Gabon',
  },
  {
    defaultValue: false,
    label: 'Gambia',
    value: 'Gambia',
  },
  {
    defaultValue: false,
    label: 'Georgia',
    value: 'Georgia',
  },
  {
    defaultValue: false,
    label: 'Germany',
    value: 'Germany',
  },
  {
    defaultValue: false,
    label: 'Ghana',
    value: 'Ghana',
  },
  {
    defaultValue: false,
    label: 'Gibraltar',
    value: 'Gibraltar',
  },
  {
    defaultValue: false,
    label: 'Greece',
    value: 'Greece',
  },
  {
    defaultValue: false,
    label: 'Greenland',
    value: 'Greenland',
  },
  {
    defaultValue: false,
    label: 'Grenada',
    value: 'Grenada',
  },
  {
    defaultValue: false,
    label: 'Guadeloupe',
    value: 'Guadeloupe',
  },
  {
    defaultValue: false,
    label: 'Guam',
    value: 'Guam',
  },
  {
    defaultValue: false,
    label: 'Guatemala',
    value: 'Guatemala',
  },
  {
    defaultValue: false,
    label: 'Guernsey',
    value: 'Guernsey',
  },
  {
    defaultValue: false,
    label: 'Guinea',
    value: 'Guinea',
  },
  {
    defaultValue: false,
    label: 'Guinea-Bissau',
    value: 'Guinea-Bissau',
  },
  {
    defaultValue: false,
    label: 'Guyana',
    value: 'Guyana',
  },
  {
    defaultValue: false,
    label: 'Haiti',
    value: 'Haiti',
  },
  {
    defaultValue: false,
    label: 'Heard Island and McDonald Islands',
    value: 'Heard Island and McDonald Islands',
  },
  {
    defaultValue: false,
    label: 'Holy See',
    value: 'Holy See',
  },
  {
    defaultValue: false,
    label: 'Honduras',
    value: 'Honduras',
  },
  {
    defaultValue: false,
    label: 'Hong Kong',
    value: 'Hong Kong',
  },
  {
    defaultValue: false,
    label: 'Hungary',
    value: 'Hungary',
  },
  {
    defaultValue: false,
    label: 'Iceland',
    value: 'Iceland',
  },
  {
    defaultValue: false,
    label: 'India',
    value: 'India',
  },
  {
    defaultValue: false,
    label: 'Indonesia',
    value: 'Indonesia',
  },
  {
    defaultValue: false,
    label: 'Iran (Islamic Republic of)',
    value: 'Iran (Islamic Republic of)',
  },
  {
    defaultValue: false,
    label: 'Iraq',
    value: 'Iraq',
  },
  {
    defaultValue: false,
    label: 'Ireland',
    value: 'Ireland',
  },
  {
    defaultValue: false,
    label: 'Isle of Man',
    value: 'Isle of Man',
  },
  {
    defaultValue: false,
    label: 'Israel',
    value: 'Israel',
  },
  {
    defaultValue: false,
    label: 'Italy',
    value: 'Italy',
  },
  {
    defaultValue: false,
    label: 'Jamaica',
    value: 'Jamaica',
  },
  {
    defaultValue: false,
    label: 'Japan',
    value: 'Japan',
  },
  {
    defaultValue: false,
    label: 'Jersey',
    value: 'Jersey',
  },
  {
    defaultValue: false,
    label: 'Jordan',
    value: 'Jordan',
  },
  {
    defaultValue: false,
    label: 'Kazakhstan',
    value: 'Kazakhstan',
  },
  {
    defaultValue: false,
    label: 'Kenya',
    value: 'Kenya',
  },
  {
    defaultValue: false,
    label: 'Kiribati',
    value: 'Kiribati',
  },
  {
    defaultValue: false,
    label: "Korea (the Democratic People's Republic of)",
    value: "Korea (the Democratic People's Republic of)",
  },
  {
    defaultValue: false,
    label: 'Korea (the Republic of)',
    value: 'Korea (the Republic of)',
  },
  {
    defaultValue: false,
    label: 'Kuwait',
    value: 'Kuwait',
  },
  {
    defaultValue: false,
    label: 'Kyrgyzstan',
    value: 'Kyrgyzstan',
  },
  {
    defaultValue: false,
    label: "Lao People's Democratic Republic",
    value: "Lao People's Democratic Republic",
  },
  {
    defaultValue: false,
    label: 'Latvia',
    value: 'Latvia',
  },
  {
    defaultValue: false,
    label: 'Lebanon',
    value: 'Lebanon',
  },
  {
    defaultValue: false,
    label: 'Lesotho',
    value: 'Lesotho',
  },
  {
    defaultValue: false,
    label: 'Liberia',
    value: 'Liberia',
  },
  {
    defaultValue: false,
    label: 'Libya',
    value: 'Libya',
  },
  {
    defaultValue: false,
    label: 'Liechtenstein',
    value: 'Liechtenstein',
  },
  {
    defaultValue: false,
    label: 'Lithuania',
    value: 'Lithuania',
  },
  {
    defaultValue: false,
    label: 'Luxembourg',
    value: 'Luxembourg',
  },
  {
    defaultValue: false,
    label: 'Macao',
    value: 'Macao',
  },
  {
    defaultValue: false,
    label: 'Madagascar',
    value: 'Madagascar',
  },
  {
    defaultValue: false,
    label: 'Malawi',
    value: 'Malawi',
  },
  {
    defaultValue: false,
    label: 'Malaysia',
    value: 'Malaysia',
  },
  {
    defaultValue: false,
    label: 'Maldives',
    value: 'Maldives',
  },
  {
    defaultValue: false,
    label: 'Mali',
    value: 'Mali',
  },
  {
    defaultValue: false,
    label: 'Malta',
    value: 'Malta',
  },
  {
    defaultValue: false,
    label: 'Marshall Islands',
    value: 'Marshall Islands',
  },
  {
    defaultValue: false,
    label: 'Martinique',
    value: 'Martinique',
  },
  {
    defaultValue: false,
    label: 'Mauritania',
    value: 'Mauritania',
  },
  {
    defaultValue: false,
    label: 'Mauritius',
    value: 'Mauritius',
  },
  {
    defaultValue: false,
    label: 'Mayotte',
    value: 'Mayotte',
  },
  {
    defaultValue: false,
    label: 'Mexico',
    value: 'Mexico',
  },
  {
    defaultValue: false,
    label: 'Micronesia (Federated States of)',
    value: 'Micronesia (Federated States of)',
  },
  {
    defaultValue: false,
    label: 'Moldova (the Republic of)',
    value: 'Moldova (the Republic of)',
  },
  {
    defaultValue: false,
    label: 'Monaco',
    value: 'Monaco',
  },
  {
    defaultValue: false,
    label: 'Mongolia',
    value: 'Mongolia',
  },
  {
    defaultValue: false,
    label: 'Montenegro',
    value: 'Montenegro',
  },
  {
    defaultValue: false,
    label: 'Montserrat',
    value: 'Montserrat',
  },
  {
    defaultValue: false,
    label: 'Morocco',
    value: 'Morocco',
  },
  {
    defaultValue: false,
    label: 'Mozambique',
    value: 'Mozambique',
  },
  {
    defaultValue: false,
    label: 'Myanmar',
    value: 'Myanmar',
  },
  {
    defaultValue: false,
    label: 'Namibia',
    value: 'Namibia',
  },
  {
    defaultValue: false,
    label: 'Nauru',
    value: 'Nauru',
  },
  {
    defaultValue: false,
    label: 'Nepal',
    value: 'Nepal',
  },
  {
    defaultValue: false,
    label: 'Netherlands',
    value: 'Netherlands',
  },
  {
    defaultValue: false,
    label: 'New Caledonia',
    value: 'New Caledonia',
  },
  {
    defaultValue: false,
    label: 'New Zealand',
    value: 'New Zealand',
  },
  {
    defaultValue: false,
    label: 'Nicaragua',
    value: 'Nicaragua',
  },
  {
    defaultValue: false,
    label: 'Niger',
    value: 'Niger',
  },
  {
    defaultValue: false,
    label: 'Nigeria',
    value: 'Nigeria',
  },
  {
    defaultValue: false,
    label: 'Niue',
    value: 'Niue',
  },
  {
    defaultValue: false,
    label: 'Norfolk Island',
    value: 'Norfolk Island',
  },
  {
    defaultValue: false,
    label: 'Northern Mariana Islands',
    value: 'Northern Mariana Islands',
  },
  {
    defaultValue: false,
    label: 'Norway',
    value: 'Norway',
  },
  {
    defaultValue: false,
    label: 'Oman',
    value: 'Oman',
  },
  {
    defaultValue: false,
    label: 'Pakistan',
    value: 'Pakistan',
  },
  {
    defaultValue: false,
    label: 'Palau',
    value: 'Palau',
  },
  {
    defaultValue: false,
    label: 'Palestine, State of',
    value: 'Palestine, State of',
  },
  {
    defaultValue: false,
    label: 'Panama',
    value: 'Panama',
  },
  {
    defaultValue: false,
    label: 'Papua New Guinea',
    value: 'Papua New Guinea',
  },
  {
    defaultValue: false,
    label: 'Paraguay',
    value: 'Paraguay',
  },
  {
    defaultValue: false,
    label: 'Peru',
    value: 'Peru',
  },
  {
    defaultValue: false,
    label: 'Philippines',
    value: 'Philippines',
  },
  {
    defaultValue: false,
    label: 'Pitcairn',
    value: 'Pitcairn',
  },
  {
    defaultValue: false,
    label: 'Poland',
    value: 'Poland',
  },
  {
    defaultValue: false,
    label: 'Portugal',
    value: 'Portugal',
  },
  {
    defaultValue: false,
    label: 'Puerto Rico',
    value: 'Puerto Rico',
  },
  {
    defaultValue: false,
    label: 'Qatar',
    value: 'Qatar',
  },
  {
    defaultValue: false,
    label: 'Republic of North Macedonia',
    value: 'Republic of North Macedonia',
  },
  {
    defaultValue: false,
    label: 'Romania',
    value: 'Romania',
  },
  {
    defaultValue: false,
    label: 'Russian Federation',
    value: 'Russian Federation',
  },
  {
    defaultValue: false,
    label: 'Rwanda',
    value: 'Rwanda',
  },
  {
    defaultValue: false,
    label: 'Réunion',
    value: 'Réunion',
  },
  {
    defaultValue: false,
    label: 'Saint Barthélemy',
    value: 'Saint Barthélemy',
  },
  {
    defaultValue: false,
    label: 'Saint Helena, Ascension and Tristan da Cunha',
    value: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  {
    defaultValue: false,
    label: 'Saint Kitts and Nevis',
    value: 'Saint Kitts and Nevis',
  },
  {
    defaultValue: false,
    label: 'Saint Lucia',
    value: 'Saint Lucia',
  },
  {
    defaultValue: false,
    label: 'Saint Martin (French part)',
    value: 'Saint Martin (French part)',
  },
  {
    defaultValue: false,
    label: 'Saint Pierre and Miquelon',
    value: 'Saint Pierre and Miquelon',
  },
  {
    defaultValue: false,
    label: 'Saint Vincent and the Grenadines',
    value: 'Saint Vincent and the Grenadines',
  },
  {
    defaultValue: false,
    label: 'Samoa',
    value: 'Samoa',
  },
  {
    defaultValue: false,
    label: 'San Marino',
    value: 'San Marino',
  },
  {
    defaultValue: false,
    label: 'Sao Tome and Principe',
    value: 'Sao Tome and Principe',
  },
  {
    defaultValue: false,
    label: 'Saudi Arabia',
    value: 'Saudi Arabia',
  },
  {
    defaultValue: false,
    label: 'Senegal',
    value: 'Senegal',
  },
  {
    defaultValue: false,
    label: 'Serbia',
    value: 'Serbia',
  },
  {
    defaultValue: false,
    label: 'Seychelles',
    value: 'Seychelles',
  },
  {
    defaultValue: false,
    label: 'Sierra Leone',
    value: 'Sierra Leone',
  },
  {
    defaultValue: false,
    label: 'Singapore',
    value: 'Singapore',
  },
  {
    defaultValue: false,
    label: 'Sint Maarten (Dutch part)',
    value: 'Sint Maarten (Dutch part)',
  },
  {
    defaultValue: false,
    label: 'Slovakia',
    value: 'Slovakia',
  },
  {
    defaultValue: false,
    label: 'Slovenia',
    value: 'Slovenia',
  },
  {
    defaultValue: false,
    label: 'Solomon Islands',
    value: 'Solomon Islands',
  },
  {
    defaultValue: false,
    label: 'Somalia',
    value: 'Somalia',
  },
  {
    defaultValue: false,
    label: 'South Africa',
    value: 'South Africa',
  },
  {
    defaultValue: false,
    label: 'South Georgia and the South Sandwich Islands',
    value: 'South Georgia and the South Sandwich Islands',
  },
  {
    defaultValue: false,
    label: 'South Sudan',
    value: 'South Sudan',
  },
  {
    defaultValue: false,
    label: 'Spain',
    value: 'Spain',
  },
  {
    defaultValue: false,
    label: 'Sri Lanka',
    value: 'Sri Lanka',
  },
  {
    defaultValue: false,
    label: 'Sudan',
    value: 'Sudan',
  },
  {
    defaultValue: false,
    label: 'Suriname',
    value: 'Suriname',
  },
  {
    defaultValue: false,
    label: 'Svalbard and Jan Mayen',
    value: 'Svalbard and Jan Mayen',
  },
  {
    defaultValue: false,
    label: 'Sweden',
    value: 'Sweden',
  },
  {
    defaultValue: false,
    label: 'Switzerland',
    value: 'Switzerland',
  },
  {
    defaultValue: false,
    label: 'Syrian Arab Republic',
    value: 'Syrian Arab Republic',
  },
  {
    defaultValue: false,
    label: 'Taiwan (Province of China)',
    value: 'Taiwan (Province of China)',
  },
  {
    defaultValue: false,
    label: 'Tajikistan',
    value: 'Tajikistan',
  },
  {
    defaultValue: false,
    label: 'Tanzania, United Republic of',
    value: 'Tanzania, United Republic of',
  },
  {
    defaultValue: false,
    label: 'Thailand',
    value: 'Thailand',
  },
  {
    defaultValue: false,
    label: 'Timor-Leste',
    value: 'Timor-Leste',
  },
  {
    defaultValue: false,
    label: 'Togo',
    value: 'Togo',
  },
  {
    defaultValue: false,
    label: 'Tokelau',
    value: 'Tokelau',
  },
  {
    defaultValue: false,
    label: 'Tonga',
    value: 'Tonga',
  },
  {
    defaultValue: false,
    label: 'Trinidad and Tobago',
    value: 'Trinidad and Tobago',
  },
  {
    defaultValue: false,
    label: 'Tunisia',
    value: 'Tunisia',
  },
  {
    defaultValue: false,
    label: 'Turkey',
    value: 'Turkey',
  },
  {
    defaultValue: false,
    label: 'Turkmenistan',
    value: 'Turkmenistan',
  },
  {
    defaultValue: false,
    label: 'Turks and Caicos Islands',
    value: 'Turks and Caicos Islands',
  },
  {
    defaultValue: false,
    label: 'Tuvalu',
    value: 'Tuvalu',
  },
  {
    defaultValue: false,
    label: 'Uganda',
    value: 'Uganda',
  },
  {
    defaultValue: false,
    label: 'Ukraine',
    value: 'Ukraine',
  },
  {
    defaultValue: false,
    label: 'United Arab Emirates',
    value: 'United Arab Emirates',
  },
  {
    defaultValue: false,
    label: 'United Kingdom of Great Britain and Northern Ireland',
    value: 'United Kingdom of Great Britain and Northern Ireland',
  },
  {
    defaultValue: false,
    label: 'United States Minor Outlying Islands',
    value: 'United States Minor Outlying Islands',
  },

  {
    defaultValue: false,
    label: 'Uruguay',
    value: 'Uruguay',
  },
  {
    defaultValue: false,
    label: 'Uzbekistan',
    value: 'Uzbekistan',
  },
  {
    defaultValue: false,
    label: 'Vanuatu',
    value: 'Vanuatu',
  },
  {
    defaultValue: false,
    label: 'Venezuela (Bolivarian Republic of)',
    value: 'Venezuela (Bolivarian Republic of)',
  },
  {
    defaultValue: false,
    label: 'Viet Nam',
    value: 'Viet Nam',
  },
  {
    defaultValue: false,
    label: 'Virgin Islands (British)',
    value: 'Virgin Islands (British)',
  },
  {
    defaultValue: false,
    label: 'Virgin Islands (U.S.)',
    value: 'Virgin Islands (U.S.)',
  },
  {
    defaultValue: false,
    label: 'Wallis and Futuna',
    value: 'Wallis and Futuna',
  },
  {
    defaultValue: false,
    label: 'Western Sahara',
    value: 'Western Sahara',
  },
  {
    defaultValue: false,
    label: 'Yemen',
    value: 'Yemen',
  },
  {
    defaultValue: false,
    label: 'Zambia',
    value: 'Zambia',
  },
  {
    defaultValue: false,
    label: 'Zimbabwe',
    value: 'Zimbabwe',
  },
  { label: 'Other', value: 'Other', defaultValue: false },
];
